export default {
  async getDeliveryItems(
    deliveryId: string,
    target?: Ref<DeliveryItem[]>,
    abortSignal?: AbortSignal,
  ) {
    const { getDocuments, collection } = useFirestore()
    const items = await getDocuments<DeliveryItem>(
      collection(`PlannedDeliveries/${deliveryId}/DeliveryItems`),
      {
        target,
        signal: abortSignal,
      },
    )
    return items
  },
  async getDeliveryItem(
    deliveryId: string,
    itemId: string,
    target?: Ref<DeliveryItem | null>,
    abortSignal?: AbortSignal,
  ) {
    const { getDocument } = useFirestore()
    const items = await getDocument<DeliveryItem>(
      ['PlannedDeliveries', deliveryId, 'DeliveryItems', itemId],
      {
        target,
        signal: abortSignal,
      },
    )
    return items
  },
}
